module.exports = __webpack_public_path__ + "static/media/finished.ef1b5ebc.png";